import React from "react";
import {
  Container,
  CountDown,
  MatchStartTime,
  Score,
  ScoreWrapper,
  SetScore,
  SetScoreBullet,
  StateWrapper,
  Status,
  TeamLogo,
  TeamNameWrapper,
  TeamWrapper,
  TitleWrapper,
  Button,
  ButtonWrapper,
} from "./styled";
import SportsTeamLogo from "../../../teamLogo";
import { observer } from "mobx-react";
import moment from "moment";
import "moment/locale/ko";
import BoxScore from "./BoxScore";
import { getStreamBrowser } from "../../../../routes/score/liveStream/util";

const VolleyBallMatch = observer(({ gameData }) => {
  const { detail } = gameData;

  const {
    teams,
    gameStatus,
    startDatetime,
    league,
    betbleUri,
    videoLink,
    betbleButtonVisible,
    champGameId,
  } = detail;

  const homeTeam = teams.home;
  const awayTeam = teams.away;

  const formattedDateTime = moment(startDatetime)
    .locale("ko")
    .format("MM.DD (ddd) HH:mm");

  const handleClickBetbleLink = () => {
    let type = 0;

    if (detail.getTracker.status === "progress") {
      type = 1;
    }
    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;
    window.open(url);
  };

  const onClickVideo = () => {
    getStreamBrowser(videoLink);
  };

  return (
    <Container>
      <TitleWrapper>
        <TeamWrapper>
          <TeamLogo>
            <SportsTeamLogo
              imgSize={"70"}
              imgUrl={homeTeam.imgPath}
              isLazy={true}
            />
          </TeamLogo>
          <TeamNameWrapper>
            <p>{homeTeam.name}</p>
            <span>
              {league.name} {homeTeam.seasonRecord.ranking}위
            </span>
          </TeamNameWrapper>
        </TeamWrapper>
        <Status>
          {gameStatus === "READY" && <CountDownComp detail={detail} />}
          {gameStatus !== "READY" && <ScoreComp detail={detail} />}

          <MatchStartTime>{formattedDateTime}</MatchStartTime>
          <ButtonWrapper>
            {/*{!!champGameId && (*/}
            {/*  <Button*/}
            {/*    champ*/}
            {/*    href={`https://champscore.com/volleyball/${champGameId}`}*/}
            {/*    target={'_blank'}*/}
            {/*  >*/}
            {/*    챔프*/}
            {/*  </Button>*/}
            {/*)}*/}
            {videoLink &&  ( gameStatus === "IN_PROGRESS" || gameStatus === "BREAK_TIME" || gameStatus === "PAUSE" ) && (
              <Button onClick={onClickVideo} target={"_blank"} onAir>
                생중계
              </Button>
            )}
            {/*{betbleButtonVisible && (*/}
            {/*  <Button onClick={handleClickBetbleLink} betble>*/}
            {/*    베팅하기*/}
            {/*  </Button>*/}
            {/*)}*/}
          </ButtonWrapper>
        </Status>
        <TeamWrapper>
          <TeamLogo>
            <SportsTeamLogo
              imgSize={"70"}
              imgUrl={awayTeam.imgPath}
              isLazy={true}
            />
          </TeamLogo>
          <TeamNameWrapper>
            <p>{awayTeam.name}</p>
            <span>
              {league.name} {awayTeam.seasonRecord.ranking}위
            </span>
          </TeamNameWrapper>
        </TeamWrapper>
      </TitleWrapper>

      <BoxScore detail={detail} />
    </Container>
  );
});

const CountDownComp = observer(({ detail }) => {
  return <CountDown>{detail.getCountDownTime}</CountDown>;
});

const ScoreComp = observer(({ detail }) => {
  const {
    homeTotalScore,
    awayTotalScore,
    gameStatus,
    volleyBallPeriodScore,
    getTotalSetScore,
  } = detail;

  const { home, away } = detail.getTeamData;

  const bulletCount =
    getTotalSetScore.away > getTotalSetScore.home
      ? getTotalSetScore.away
      : getTotalSetScore.home;

  return (
    <ScoreWrapper>
      <Score winPosition={homeTotalScore > awayTotalScore}>
        {gameStatus === "IN_PROGRESS" && (
          <SetScoreComp count={bulletCount} setScore={getTotalSetScore.home} />
        )}
        {gameStatus !== "IN_PROGRESS" && home.score}
        {gameStatus === "IN_PROGRESS" && volleyBallPeriodScore.home.score}
      </Score>
      <StateWrapper>
        <span>{detail.statusText}</span>
        {gameStatus === "IN_PROGRESS" && <span>{detail.displayTime}</span>}
      </StateWrapper>
      <Score winPosition={awayTotalScore > homeTotalScore}>
        {gameStatus === "IN_PROGRESS" && (
          <SetScoreComp count={bulletCount} setScore={getTotalSetScore.away} />
        )}
        {gameStatus !== "IN_PROGRESS" && away.score}
        {gameStatus === "IN_PROGRESS" && volleyBallPeriodScore.away.score}
      </Score>
    </ScoreWrapper>
  );
});

const SetScoreComp = observer(({ count, setScore }) => {
  const bulletComp = [];

  for (let num = 1; num <= count; num++) {
    let isActive = num <= setScore;
    bulletComp.push(<SetScoreBullet key={num} isActive={isActive} />);
  }
  return <SetScore>{bulletComp}</SetScore>;
});

export default VolleyBallMatch;
